export enum ESlice {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}

export enum EType {
  ALL,
  UNIQUE,
  NEW,
}

export type TNormalizedItem = {
  date: string;
  clients: number;
  guests: number;
  total: number;
  newClients: number;
  clientSessions: number;
  guestSessions: number;
};
